// extracted by mini-css-extract-plugin
export default {"minorHeader":"MinorHeader_minorHeader__uUZPX","minorDescr":"MinorHeader_minorDescr__GGC4A"};